import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('@/views/HomePage.vue'),
    name: 'HomePage',
    meta: { keepAlive: true },
  },
  {
    path: '/schoolSearch',
    component: () => import('@/views/SchoolSearch.vue'),
    name: 'SchoolSearch',
    meta: { keepAlive: true },
  },
  {
    path: '/schoolDetail',
    component: () => import('@/views/details/SchoolDetail/SchoolDetail.vue'),
    name: 'SchoolDetail',
    meta: { keepAlive: true },
  },
  {
    path: '/scoreSearch',
    component: () => import('@/views/ScoreSearch.vue'),
    name: 'ScoreSearch',
    meta: { keepAlive: true },
  },
  {
    path: '/scoreDetailsImage',
    component: () => import('@/views/ScoreDetailsImage.vue'),
    name: 'ScoreDetailsImage',
  },
  {
    path: '/scoreDetailsLongImage',
    component: () => import('@/views/ScoreDetailsLongImage.vue'),
    name: 'ScoreDetailsLongImage',
  },
  {
    path: '/scoreDetailsTable',
    component: () => import('@/views/ScoreDetailsTable.vue'),
    name: 'ScoreDetailsTable',
  },
  {
    path: '/scoreDetailsTableTabs',
    component: () => import('@/views/ScoreDetailsTableTabs.vue'),
    name: 'scoreDetailsTableTabs',
  },
  {
    path: '/audioDetail',
    name: 'AudioDetail',
    component: () => import('@/views/details/AudioDetail/AudioDetail.vue'),
  },
  {
    path: '/videoDetail',
    name: 'VideoDetail',
    component: () => import('@/views/details/VideoDetail/VideoDetail.vue'),
  },
  {
    path: '/videoSingleDetail',
    name: 'VideoSingleDetail',
    component: () => import('@/views/details/VideoDetail/VideoSingleDetail.vue'),
  },
  {
    path: '/imageDetail',
    name: 'ImageDetail',
    component: () => import('@/views/details/ImageDetail/ImageDetail.vue'),
  },
  {
    path: '/textDetail',
    name: 'TextDetail',
    component: () => import('@/views/details/TextDetail/TextDetail.vue'),
  },
  {
    path: '/liveDetail',
    name: 'LiveDetail',
    component: () => import('@/views/details/LiveDetail/LiveDetail.vue'),
  },
  {
    path: '/topicDetail',
    name: 'TopicDetail',
    component: () => import('@/views/details/TopicDetail/TopicDetail.vue'),
    meta: { keepAlive: true },
  },
  {
    path: '/groupDetail',
    name: 'GroupDetail',
    component: () => import('@/views/details/TopicDetail/GroupDetail.vue'),
    meta: { keepAlive: true },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
